import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Typography, Checkbox, Link } from '@mui/material'
import DocumentInput from './DocumentInput'
import { Column, Row } from 'src/components/Layout/Styled'
import { getQueryParams, isMediaWidthMoreThan } from 'src/utils/lib'
import { fetchLearnerDocument, handleConsent } from './event'
import { setReduxValue } from 'src/redux/slices/class/enroll' // ✅ เพิ่ม import
import _ from 'lodash'
import { useParams } from 'react-router-dom'

const Document = () => {
  const dispatch = useDispatch()
  const [checkConsent, setCheckConsent] = useState(false) // ✅ สร้าง state
  const isNotSm = isMediaWidthMoreThan('sm')

  const { data, requestData } = useSelector(
    (state) => state.document,
    shallowEqual
  )

  const { id: uuid } = useParams()
  const classLearner = getQueryParams('id')

  const trainingPlanUuid = useSelector(
    (state) => state.classEnroll.enrollProps?.trainingPlanUuid
  )

  const payload = { uuid, classLearner, requestData, trainingPlanUuid }
  const documentList = _.get(data, 'documentList', [])

  useEffect(() => {
    dispatch(fetchLearnerDocument(payload))
  }, [])

  // ✅ sync checkConsent state ไป redux
  useEffect(() => {
    dispatch(setReduxValue({ index: 'consent', value: checkConsent }))
  }, [checkConsent])

  const hasDocuments = documentList.length > 0
  const consentMarginTop = hasDocuments ? 1 : -1

  return (
    <Column sx={{ gap: 3, mt: 1 }}>
      {documentList.map((item, idx) => (
        <DocumentInput
          key={idx}
          index={idx}
          label={item.title}
          isAllow={item.allow}
        />
      ))}

      <Row sx={{ alignItems: 'flex-start', mt: consentMarginTop, ml: -1 }}>
        <Checkbox
          data-testid="checkbox-consent"
          checked={checkConsent}
          onChange={(e) => setCheckConsent(e.target.checked)} // ✅ อัปเดต state
          sx={{ mt: -1.2 }}
        />
        <Typography variant="body1" color="text.primary">
          ผู้เรียนยินยอมที่จะเผยแพร่เอกสารที่มีข้อมูล
          {!isNotSm && <br />}ส่วนบุคคลเพื่อใช้ในการสมัคร
          <Link
            data-testid="btn-consent"
            component="span"
            onClick={() => dispatch(handleConsent())}
            sx={{ ml: 1, cursor: 'pointer', fontSize: 'inherit' }}
          >
            อ่านเพิ่มเติม
          </Link>
        </Typography>
      </Row>
    </Column>
  )
}

export default Document
